import { CSSProperties } from 'react';

import styles from './Message.module.scss';

export const mediaSizeSetup = (width: number, height: number) => {
  const size = 20;
  const maxSize = `var(--max-message-width) - ${styles.hSpacing}`;
  const aspect = width / height;

  const style: CSSProperties = {};

  if (width > height) {
    style.width = `${size}rem`;
    style.maxWidth = `calc(${maxSize})`;

    style.height = `${size / aspect}rem`;
    style.maxHeight = `calc((${maxSize}) / ${aspect})`;
  } else {
    style.width = `${size * aspect}rem`;
    style.maxWidth = `calc((${maxSize}) * ${aspect})`;

    style.height = `${size}rem`;
    style.maxHeight = `calc(${maxSize})`;
  }

  return style;
};
